import NavbarComponent from './NavbarComponent';
import { Sheet, SheetContent } from '@/components/ui/sheet';

type Props = {
  opened: boolean;
  onClose: () => void;
  onLogout?: () => void;
};

function DrawerMenu({ opened, onClose, onLogout }: Props) {
  return (
    <Sheet open={opened} onOpenChange={(open) => !open && onClose()}>
      <SheetContent
        side="left"
        className="w-[min(100vw,20rem)] border-none bg-transparent p-0 shadow-none [&>button]:text-white"
      >
        <NavbarComponent expanded pinnedExpanded onLogout={onLogout} />
      </SheetContent>
    </Sheet>
  );
}

export default DrawerMenu;
